import { createRef } from 'react';

export default createRef();